import { useEffect, useState } from 'react';
import axios from 'axios';

let cachedSiteInfo = null;
let fetchPromise = null;

/**
 * Hook to fetch and cache public site info (logo, favicon, site name).
 * Uses a singleton cache so it only fetches once across the entire app.
 */
export function useSiteInfo() {
  const [siteInfo, setSiteInfo] = useState(cachedSiteInfo);

  useEffect(() => {
    if (cachedSiteInfo) {
      setSiteInfo(cachedSiteInfo);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = axios.get('/api/site-info')
        .then(res => {
          cachedSiteInfo = res.data;
          return res.data;
        })
        .catch(() => {
          cachedSiteInfo = { site_name: 'WyrdMaker', logo_url: '', favicon_url: '' };
          return cachedSiteInfo;
        });
    }

    fetchPromise.then(data => setSiteInfo(data));
  }, []);

  return siteInfo || { site_name: 'WyrdMaker', logo_url: '', favicon_url: '' };
}

/**
 * Component that injects a dynamic favicon from admin settings.
 * Place this once in your App root.
 */
export function DynamicFavicon() {
  const siteInfo = useSiteInfo();

  useEffect(() => {
    if (siteInfo.favicon_url) {
      // Update existing favicon link or create one
      let link = document.querySelector("link[rel~='icon'][data-dynamic]");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        link.setAttribute('data-dynamic', 'true');
        document.head.appendChild(link);
      }
      link.href = siteInfo.favicon_url;
    }
  }, [siteInfo.favicon_url]);

  return null;
}

export default useSiteInfo;
